module.exports = __webpack_public_path__ + "static/media/5-item-c.b58a5876.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/men/5-item-c.jpg
// module id = 1174
// module chunks = 33